import React, { createElement } from 'react';
interface Logo3DProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  animated?: boolean;
}
export function Logo3D({
  size = 'md',
  animated = true
}: Logo3DProps) {
  const sizes = {
    sm: 'h-12 w-12',
    md: 'h-16 w-16',
    lg: 'h-24 w-24',
    xl: 'h-32 w-32'
  };
  return <div className={`${sizes[size]} relative ${animated ? 'animate-float' : ''}`} data-id="element-214">
      <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full drop-shadow-2xl" data-id="element-215">
        <defs data-id="element-216">
          {/* Gradients for 3D effect */}
          <linearGradient id="gradient-top" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-217">
            <stop offset="0%" stopColor="#667eea" data-id="element-218" />
            <stop offset="100%" stopColor="#764ba2" data-id="element-219" />
          </linearGradient>

          <linearGradient id="gradient-left" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-220">
            <stop offset="0%" stopColor="#4c51bf" data-id="element-221" />
            <stop offset="100%" stopColor="#667eea" data-id="element-222" />
          </linearGradient>

          <linearGradient id="gradient-right" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-223">
            <stop offset="0%" stopColor="#764ba2" data-id="element-224" />
            <stop offset="100%" stopColor="#9333ea" data-id="element-225" />
          </linearGradient>

          {/* Glow effect */}
          <filter id="glow" data-id="element-226">
            <feGaussianBlur stdDeviation="4" result="coloredBlur" data-id="element-227" />
            <feMerge data-id="element-228">
              <feMergeNode in="coloredBlur" data-id="element-229" />
              <feMergeNode in="SourceGraphic" data-id="element-230" />
            </feMerge>
          </filter>

          {/* Shadow */}
          <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%" data-id="element-231">
            <feDropShadow dx="0" dy="8" stdDeviation="8" floodOpacity="0.3" data-id="element-232" />
          </filter>
        </defs>

        {/* 3D Cube representing growth/analytics */}
        <g filter="url(#shadow)" data-id="element-233">
          {/* Top face - Bar chart rising */}
          <path d="M100 40 L160 70 L160 90 L100 60 Z" fill="url(#gradient-top)" opacity="0.95" data-id="element-234" />

          {/* Left face */}
          <path d="M40 70 L100 40 L100 60 L40 90 Z" fill="url(#gradient-left)" opacity="0.85" data-id="element-235" />

          {/* Right face */}
          <path d="M100 60 L160 90 L160 150 L100 120 Z" fill="url(#gradient-right)" opacity="0.9" data-id="element-236" />

          {/* Bar chart elements on top face */}
          <g filter="url(#glow)" data-id="element-237">
            {/* Bar 1 - shortest */}
            <rect x="110" y="55" width="12" height="20" fill="#fbbf24" opacity="0.9" rx="2" data-id="element-238" />

            {/* Bar 2 - medium */}
            <rect x="125" y="48" width="12" height="27" fill="#f59e0b" opacity="0.9" rx="2" data-id="element-239" />

            {/* Bar 3 - tallest (growth!) */}
            <rect x="140" y="38" width="12" height="37" fill="#ea580c" opacity="0.95" rx="2" data-id="element-240" />
          </g>

          {/* Sparkle/Star accent */}
          <g opacity="0.8" data-id="element-241">
            <circle cx="155" cy="35" r="3" fill="#fef3c7" filter="url(#glow)" data-id="element-242" />
            <path d="M155 30 L156 34 L160 35 L156 36 L155 40 L154 36 L150 35 L154 34 Z" fill="#fef3c7" filter="url(#glow)" data-id="element-243" />
          </g>

          {/* Connecting line showing trend */}
          <path d="M115 65 Q130 55 145 45" stroke="#fbbf24" strokeWidth="2" fill="none" opacity="0.6" strokeLinecap="round" data-id="element-244" />
        </g>

        {/* Base shadow */}
        <ellipse cx="100" cy="165" rx="50" ry="8" fill="#1e293b" opacity="0.15" data-id="element-245" />
      </svg>
    </div>;
}
// Floating animation
const style = document.createElement('style');
style.textContent = `
  @keyframes float {
    0%, 100% {
      transform: translateY(0px) rotate(0deg);
    }
    50% {
      transform: translateY(-10px) rotate(2deg);
    }
  }
  
  .animate-float {
    animation: float 3s ease-in-out infinite;
  }
`;
document.head.appendChild(style);